import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const RestaurantSolutionPage = () => {
  useEffect(() => {
    document.title = 'Restoran Dijital Çözümü | QR Menü, POS, Online Sipariş, Kurye, Yapay Zeka';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Restoranlar için QR menü, POS, online sipariş, kurye takibi ve yapay zeka modülleri. QR Menü ücretsiz; AI 15 gün, diğer modüller 30 gün ücretsiz.');

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Restoran Dijital Çözümü',
      serviceType: 'Restoran Otomasyon Sistemi',
      areaServed: 'TR',
      provider: {
        '@type': 'Organization',
        name: 'Cafe Otomasyonu'
      }
    };
    // Canonical
    const canonicalHref = `${siteUrl}/solutions/restaurant`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Restoranlar için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">Yüksek hacimli sipariş akışlarını; QR Menü, POS, Online Sipariş, Kurye ve Yapay Zeka modülleriyle tek panelden yönetin. Mutfağa–servise hızlı akış, hatasız süreç.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>Mutfak fişi–masa fişi ayrımı, çoklu yazıcı desteği</li>
                <li>Yoğun saatler için hızlı POS arayüzü</li>
                <li>Kurye performansı ve rota optimizasyonu</li>
                <li>Yapay Zeka ile kârlı menü ve kampanya önerileri</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Restoranlar İçin Uygun Modüller</h2>
            <p>Yoğun sipariş, mutfak–salon koordinasyonu ve teslimat karmaşıklığı restoranlarda kritiktir. Aşağıdaki modüllerle süreci uçtan uca yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">QR Menü</h3>
            <p>Temassız <a className="text-primary underline" href="/qr-menu">QR Menü</a> ile menü değişiklikleri anında sahaya yansır; görseller ve etiketlerle seçim kolaylaşır.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">POS Sistemi</h3>
            <p><a className="text-primary underline" href="/pos-system">POS</a> ile masa, ikram, indirim, yazıcı ayrımı (mutfak/masa) ve gün sonu raporlarını hızla yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş</h3>
            <p><a className="text-primary underline" href="/online-order">Online Sipariş</a> ile bölgeler, servis saatleri, minimum sepet ve kampanyaları kolayca yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Kurye</h3>
            <p><a className="text-primary underline" href="/courier-system">Kurye</a> ile canlı konum, rota ve performans analizlerini görün; teslimat sürelerini kısaltın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Yapay Zeka</h3>
            <p><a className="text-primary underline" href="/ai-system">AI</a> ile menü optimizasyonu, talep tahmini ve trend analizleri yapın; kârlı ürünleri öne çıkarın.</p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Mutfağa ayrı yazıcı desteği var mı?</summary>
                <p className="mt-2">Evet. Mutfak ve masa fişlerini ayırabilir, birden çok yazıcı tanımlayabilirsiniz.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Online siparişlerde komisyon alınıyor mu?</summary>
                <p className="mt-2">Hayır. Online sipariş modülümüz komisyonsuz çalışır.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default RestaurantSolutionPage;


